import type { BookType } from 'xlsx';
import { SSF, utils, writeFile } from 'xlsx';

function datenum(v: any, date1904?: boolean) {
  if (date1904) v += 1462;
  const epoch = Date.parse(v);
  return (epoch - (new Date(Date.UTC(1899, 11, 30)) as unknown as number)) / (24 * 60 * 60 * 1000);
}

async function sheetFromArrayOfArrays(data: any, ws: any, percent: any) {
  return new Promise(resolve => {
    const range = {
      s: {
        c: 10000000,
        r: 10000000,
      },
      e: {
        c: 0,
        r: 0,
      },
    };

    const batchSize = 1000; // 每批的大小
    const batches = [];
    for (let i = 0; i < data.length; i += batchSize) {
      const batch = data.slice(i, i + batchSize);
      batches.push(batch);
    }
    async function export_excel_data(batch, i) {
      return new Promise(resolve1 => {
        setTimeout(() => {
          if (i === 0) {
            console.log('开始export_xlsx');
          }
          for (let R = 0; R !== batch.length; ++R) {
            for (let C = 0; C !== batch[R].length; ++C) {
              const row = R + batchSize * i;
              if (range.s.r > row) range.s.r = row;
              if (range.s.c > C) range.s.c = C;
              if (range.e.r < row) range.e.r = row;
              if (range.e.c < C) range.e.c = C;
              const cell: Record<string, any> = {
                v: batch[R][C],
              };
              if (cell.v == null) continue;
              const cellRef = utils.encode_cell({
                c: C,
                r: row,
              });

              if (typeof cell.v === 'number') cell.t = 'n';
              else if (typeof cell.v === 'boolean') cell.t = 'b';
              else if (cell.v instanceof Date) {
                cell.t = 'n';
                cell.z = (SSF as any)._table[14];
                cell.v = datenum(cell.v);
              } else cell.t = 's';

              // ws[cellRef] = cell;
              console.log(row, C);
              utils.sheet_add_aoa(ws, [[cell.v]], { origin: { r: row, c: C } });
            }
          }
          batch.length = 0;
          percent.value = Number(((i / batches.length) * 100 * 0.95).toFixed(0));
          console.log(`batch ${i + 1} done`);
          resolve1(true);
        }, 10);
      });
    }
    async function processArray(array) {
      for (let i = 0; i < array.length; i++) {
        await export_excel_data(array[i], i);
      }
      if (range.s.c < 10000000) ws['!ref'] = utils.encode_range(range);
      resolve(ws);
    }
    processArray(batches);
  });
}

class Workbook {
  SheetNames: any[];
  Sheets: any;

  constructor() {
    this.SheetNames = [];
    this.Sheets = {};
    if (!(this instanceof Workbook)) {
      return new Workbook();
    }
  }
}

function s2ab(s: string) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}

export type ExportJsonToExcelType = {
  multiHeader?: any[];
  header: string[];
  data: any[][];
  filename: string;
  merges?: any[];
  autoWidth: boolean;
  bookType: BookType;
  percent?: any;
};

export async function exportJsonToExcel(options: ExportJsonToExcelType) {
  const {
    multiHeader = [],
    header,
    data,
    filename,
    merges = [],
    autoWidth = true,
    bookType = 'xlsx',
    percent,
  } = options || {};
  const downloadFilename = filename || 'excel-list';
  const cloneData = data.slice();
  if (multiHeader && multiHeader.length > 0) {
    for (let i = multiHeader.length - 1; i > -1; i--) {
      cloneData.unshift(multiHeader[i]);
    }
  } else {
    cloneData.unshift(header);
  }
  const wsName = 'SheetJS';
  const wb = new Workbook();
  // const ws: any = {};
  const ws = utils.aoa_to_sheet([[]]);
  await sheetFromArrayOfArrays(cloneData, ws, percent);
  if (merges.length > 0) {
    if (!ws['!merges']) ws['!merges'] = [];
    merges.forEach(item => {
      ws['!merges'].push(item);
    });
  }

  if (autoWidth) {
    /* 设置worksheet每列的最大宽度*/
    const colWidth = cloneData.map(row =>
      row.map(val => {
        /* 先判断是否为null/undefined*/
        if (val == null) {
          return {
            wch: 10,
          };
        } else if (val.toString().charCodeAt(0) > 255) {
          /* 再判断是否为中文*/
          return {
            wch: val.toString().length * 2,
          };
        }
        return {
          wch: val.toString().length,
        };
      }),
    );
    /* 以第一行为初始值*/
    const result = colWidth[0];
    for (let i = 1; i < colWidth.length; i++) {
      for (let j = 0; j < colWidth[i].length; j++) {
        if (result[j].wch < colWidth[i][j].wch) {
          result[j].wch = colWidth[i][j].wch;
        }
      }
    }
    ws['!cols'] = result;
  }

  /* add worksheet to workbook */
  wb.SheetNames.push(wsName);
  wb.Sheets[wsName] = ws;
  console.log('start write xlsx ');

  /* export to file */
  writeFile(wb, `${downloadFilename}.${bookType}`);
}

export type ExcelExportHeaderToken = string | { text: string; color?: string };
export type ExcelExportHeaderItem = {
  title: ExcelExportHeaderToken[];
  children?: ExcelExportHeaderItem[];
};
// header 改为树形结构，函数会自动展开成多层表头并计算单元格合并：
// 1. title 表示当前表头单元格显示内容，支持 token 富文本颜色；
// 2. children 表示下级表头，叶子节点不传 children；
// 3. data 的列顺序按 header 深度优先遍历后的叶子节点顺序对应。
export type ExportJsonToExcelByTokenHeaderType = Omit<
  ExportJsonToExcelType,
  'header' | 'bookType' | 'multiHeader' | 'merges'
> & {
  header: ExcelExportHeaderItem[];
};

function getExcelCellText(value: any) {
  if (value == null) {
    return '';
  }
  return String(value);
}

function getExcelTextWidth(value: any) {
  const text = getExcelCellText(value);
  if (!text) {
    return 10;
  }
  return text.charCodeAt(0) > 255 ? text.length * 2 : text.length;
}

function getHeaderItemText(item: ExcelExportHeaderItem) {
  return (item?.title || [])
    .map(token => {
      if (typeof token === 'string') {
        return token;
      }
      return token?.text || '';
    })
    .join('');
}

function downloadExcelBuffer(buffer: ArrayBuffer, filename: string) {
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function getHeaderDepth(header: ExcelExportHeaderItem[]) {
  if (!header || header.length === 0) {
    return 0;
  }
  return Math.max(
    ...header.map(item => {
      if (item.children && item.children.length > 0) {
        return 1 + getHeaderDepth(item.children);
      }
      return 1;
    }),
  );
}

function getHeaderLeafCount(item: ExcelExportHeaderItem): number {
  if (!item.children || item.children.length === 0) {
    return 1;
  }
  return item.children.reduce((sum, child) => sum + getHeaderLeafCount(child), 0);
}

function buildHeaderLayout(header: ExcelExportHeaderItem[]) {
  const depth = getHeaderDepth(header);
  const leafCount = header.reduce((sum, item) => sum + getHeaderLeafCount(item), 0);
  const rows = Array.from({ length: depth }, () => Array.from({ length: leafCount }, () => ''));
  const richCells = [];
  const merges = [];
  const columnWidths = Array.from({ length: leafCount }, () => 10);

  const walk = (items: ExcelExportHeaderItem[], rowIndex: number, colStart: number) => {
    let currentCol = colStart;
    items.forEach(item => {
      const titleText = getHeaderItemText(item);
      const colSpan = getHeaderLeafCount(item);
      const hasChildren = !!(item.children && item.children.length > 0);
      const rowSpan = hasChildren ? 1 : depth - rowIndex;
      rows[rowIndex][currentCol] = titleText;
      richCells.push({
        row: rowIndex + 1,
        col: currentCol + 1,
        title: item.title || [],
      });
      const avgWidth = Math.max(10, Math.ceil(getExcelTextWidth(titleText) / Math.max(colSpan, 1)));
      for (let i = currentCol; i < currentCol + colSpan; i++) {
        columnWidths[i] = Math.max(columnWidths[i], avgWidth);
      }
      if (colSpan > 1 || rowSpan > 1) {
        merges.push({
          startRow: rowIndex + 1,
          startCol: currentCol + 1,
          endRow: rowIndex + rowSpan,
          endCol: currentCol + colSpan,
        });
      }
      if (hasChildren) {
        walk(item.children || [], rowIndex + 1, currentCol);
      }
      currentCol += colSpan;
    });
  };

  walk(header, 0, 0);
  return {
    depth,
    rows,
    richCells,
    merges,
    columnWidths,
  };
}

/**
 * 导出支持 token 富文本和多级表头的 xlsx 文件。
 *
 * 使用方式：
 * 1. `header` 传树形结构，每个节点都是一个表头单元格：
 *    - `title` 为当前单元格显示内容，类型是 token 数组；
 *    - `children` 为下级表头，不传时表示叶子节点。
 * 2. `title` 里的 token 支持两种格式：
 *    - 普通字符串：`'姓名'`
 *    - 带颜色对象：`{ text: '[必填]', color: 'FFFF0000' }`
 * 3. `data` 的列顺序，必须与 `header` 按从左到右展开后的叶子节点顺序一致。
 * 4. 函数内部会自动计算多级表头的横向/纵向合并，不需要再传 `multiHeader` 或 `merges`。
 *
 * 单级表头示例：
 * ```ts
 * exportJsonToExcelByTokenHeader({
 *   filename: '导入模板',
 *   header: [
 *     { title: ['姓名', { text: '[必填]', color: 'FFFF0000' }] },
 *     { title: ['手机号'] },
 *   ],
 *   data: [['张三', '13800000000']],
 *   autoWidth: true,
 * });
 * ```
 *
 * 多级表头示例：
 * ```ts
 * exportJsonToExcelByTokenHeader({
 *   filename: '导入模板',
 *   header: [
 *     {
 *       title: ['基础信息'],
 *       children: [
 *         { title: ['姓名', { text: '[必填]', color: 'FFFF0000' }] },
 *         { title: ['手机号'] },
 *       ],
 *     },
 *     {
 *       title: ['扩展信息'],
 *       children: [
 *         { title: ['备注'] },
 *       ],
 *     },
 *   ],
 *   data: [['张三', '13800000000', '测试']],
 *   autoWidth: true,
 * });
 * ```
 */
export async function exportJsonToExcelByTokenHeader(options: ExportJsonToExcelByTokenHeaderType) {
  const { header, data, filename, autoWidth = true } = options || {};
  const ExcelJSModule: any = await import('exceljs');
  const ExcelJS = ExcelJSModule.default || ExcelJSModule;
  const downloadFilename = filename || 'excel-list';
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('SheetJS');
  const headerLayout = buildHeaderLayout(header || []);

  headerLayout.rows.forEach(row => {
    worksheet.addRow((row || []).map(item => (item == null ? '' : item)));
  });
  headerLayout.richCells.forEach(item => {
    worksheet.getCell(item.row, item.col).value = {
      richText: item.title.map(token => {
        if (typeof token === 'string') {
          return { text: token };
        }
        return {
          text: token?.text || '',
          ...(token?.color
            ? {
                font: {
                  color: {
                    argb: token.color,
                  },
                },
              }
            : {}),
        };
      }),
    };
  });

  (data || []).forEach(row => {
    worksheet.addRow((row || []).map(item => (item == null ? '' : item)));
  });

  headerLayout.merges.forEach(item => {
    worksheet.mergeCells(item.startRow, item.startCol, item.endRow, item.endCol);
  });

  if (autoWidth) {
    const result = headerLayout.columnWidths.map(width => ({ width: width + 2 }));
    (data || []).forEach(row => {
      (row || []).forEach((val, index) => {
        const width = getExcelTextWidth(val);
        if (!result[index] || result[index].width < width + 2) {
          result[index] = { width: Math.max(width, 10) + 2 };
        }
      });
    });
    worksheet.columns = result;
  }

  const buffer = await workbook.xlsx.writeBuffer();
  downloadExcelBuffer(buffer as ArrayBuffer, downloadFilename);
}
